import { Box, FormGroup } from '@mui/material';
import { EmploymentType } from '../../../../../enums/work-experience-enum';
import FilterLayout from '../../../../../layouts/FilterLayout';
import CheckBox from './components/CheckBox';

interface ICandidatesEmploymentTypeFilterProps {
  label: string;
  handleSelectedEmploymentTypes: (data: string) => void;
  selectedEmploymentTypes: string[];
}

const CandidatesEmploymentTypeFilter = (
  props: ICandidatesEmploymentTypeFilterProps
) => {
  const { label, handleSelectedEmploymentTypes, selectedEmploymentTypes } =
    props;

  return (
    <FilterLayout name={label}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: '1.375rem',
          padding: '0 1rem 1.375rem',
        }}
      >
        <FormGroup>
          {Object.values(EmploymentType)?.map(employmentType => (
            <CheckBox
              key={employmentType}
              label={employmentType
                .toLowerCase()
                .replace(/_/g, '-')
                .replace(/^\w/, c => c.toUpperCase())}
              checked={selectedEmploymentTypes.includes(employmentType)}
              onChange={() => handleSelectedEmploymentTypes(employmentType)}
            />
          ))}
        </FormGroup>
      </Box>
    </FilterLayout>
  );
};

export default CandidatesEmploymentTypeFilter;
